import { ChatSessionDeleteDialog } from './ChatSessionDeleteDialog';
import { ChatSessionRenameDialog } from './ChatSessionRenameDialog';
import { ChatSessionShareDialog } from './ChatSessionShareDialog';
import { ChatSessionSystemPromptDialog } from './ChatSessionSystemPromptDialog';

type ChatSessionPendingDelete = {
  id: string;
  title: string;
  isOwner: boolean;
};

type ChatSessionPendingRename = {
  id: string;
  title: string;
};

type ChatSessionPendingShare = {
  id: string;
  title: string;
  isOwner: boolean;
};

type ChatSessionPendingSystemPrompt = {
  id: string;
  systemPrompt: string;
};

type LiksChatSessionsDialogsProps = {
  sessionPendingShare: ChatSessionPendingShare | null;
  sessionPendingRename: ChatSessionPendingRename | null;
  sessionPendingDelete: ChatSessionPendingDelete | null;
  sessionPendingSystemPrompt: ChatSessionPendingSystemPrompt | null;
  isDeleteBusy: boolean;
  renameTitle: string;
  renameLabel: string;
  renameConfirm: string;
  renameCancel: string;
  systemPromptTitle: string;
  systemPromptLabel: string;
  systemPromptConfirm: string;
  systemPromptCancel: string;
  onLeaveFromShare: (sessionId: string, title: string) => void;
  onCloseShare: () => void;
  onConfirmRename: (title: string) => void;
  onCancelRename: () => void;
  onConfirmDelete: () => void;
  onCancelDelete: () => void;
  onConfirmSystemPrompt: (prompt: string) => void;
  onCancelSystemPrompt: () => void;
};

export function LiksChatSessionsDialogs({
  sessionPendingShare,
  sessionPendingRename,
  sessionPendingDelete,
  sessionPendingSystemPrompt,
  isDeleteBusy,
  renameTitle,
  renameLabel,
  renameConfirm,
  renameCancel,
  systemPromptTitle,
  systemPromptLabel,
  systemPromptConfirm,
  systemPromptCancel,
  onLeaveFromShare,
  onCloseShare,
  onConfirmRename,
  onCancelRename,
  onConfirmDelete,
  onCancelDelete,
  onConfirmSystemPrompt,
  onCancelSystemPrompt,
}: LiksChatSessionsDialogsProps) {
  return (
    <>
      <ChatSessionShareDialog
        isOpen={sessionPendingShare !== null}
        sessionId={sessionPendingShare?.id ?? null}
        isShareMode={sessionPendingShare?.isOwner ?? true}
        sessionTitle={sessionPendingShare?.title ?? ''}
        onLeave={onLeaveFromShare}
        onClose={onCloseShare}
      />

      <ChatSessionRenameDialog
        isOpen={sessionPendingRename !== null}
        key={sessionPendingRename?.id}
        title={renameTitle}
        initialValue={sessionPendingRename?.title ?? ''}
        inputLabel={renameLabel}
        confirmLabel={renameConfirm}
        cancelLabel={renameCancel}
        onConfirm={onConfirmRename}
        onCancel={onCancelRename}
      />

      <ChatSessionDeleteDialog
        isOpen={sessionPendingDelete !== null}
        sessionId={sessionPendingDelete?.id ?? null}
        sessionTitle={sessionPendingDelete?.title ?? ''}
        isOwner={sessionPendingDelete?.isOwner ?? true}
        isBusy={isDeleteBusy}
        onConfirm={onConfirmDelete}
        onCancel={onCancelDelete}
      />

      <ChatSessionSystemPromptDialog
        isOpen={sessionPendingSystemPrompt !== null}
        key={sessionPendingSystemPrompt?.id}
        initialValue={sessionPendingSystemPrompt?.systemPrompt ?? ''}
        title={systemPromptTitle}
        inputLabel={systemPromptLabel}
        confirmLabel={systemPromptConfirm}
        cancelLabel={systemPromptCancel}
        onConfirm={onConfirmSystemPrompt}
        onCancel={onCancelSystemPrompt}
      />
    </>
  );
}
